module.exports = __webpack_public_path__ + "static/media/keyActive.b60c844e.svg";